import { CLEAR_CART } from '../constants/ActionTypes'

export default function clearCart() {
    return {
        type: CLEAR_CART,
    }
}
